<div *ngIf="job && !job.isCalcPRMultiThread">
    <app-process-details-view *ngIf="!job.isRemoveZoningCodeJob" [task]="job"></app-process-details-view>
    <app-remove-zc-job-process-details-view *ngIf="job.isRemoveZoningCodeJob"
        [process]="job"></app-remove-zc-job-process-details-view>
    <app-process-details-view *ngFor="let step of job.steps" [task]="step"></app-process-details-view>
</div>
<div *ngIf="job.isCalcPRMultiThread">
    <app-process-details-view-calc-pr-multi-thread [task]="job"></app-process-details-view-calc-pr-multi-thread>
</div>
